import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Plus, Save } from "lucide-react";
import { Modal, Input } from "./ServicesManager";
import ImageUploader from "../ImageUploader";
import MultiUploadDropzone from "../MultiUploadDropzone";
import BilingualField from "../BilingualField";

const CATS = [
  { id: "famille", label: "Famille" },
  { id: "couple", label: "Couple" },
  { id: "naissance", label: "Naissance" },
  { id: "grossesse", label: "Grossesse" },
];

export default function GalleryManager() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("tous");
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/gallery").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (editing.id) await api.put(`/gallery/${editing.id}`, editing);
    else await api.post("/gallery", editing);
    setEditing(null);
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer cette photo ?")) return;
    await api.delete(`/gallery/${id}`);
    load();
  };
  const trFr = (v) => (typeof v === "string" ? v : v?.fr || v?.en || "");

  const filtered = filter === "tous" ? items : items.filter((g) => g.category === filter);

  return (
    <div data-testid="gallery-manager">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl">Galerie</h1>
          <p className="text-[#4A3F35] mt-2">Photos par catégorie. Légende disponible en FR + EN.</p>
        </div>
        <button onClick={() => setEditing({ category: "famille", image_url: "", caption: { fr: "", en: "" }, order: items.length + 1 })} className="btn-primary" data-testid="add-gallery">
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="bg-[#FDFBF7] rounded-2xl p-2 mb-6 flex flex-wrap gap-1 border border-[#2D2A26]/10 w-fit">
        {[{ id: "tous", label: "Tous" }, ...CATS].map((c) => (
          <button key={c.id} onClick={() => setFilter(c.id)} className={`px-4 py-2 rounded-xl text-sm ${filter === c.id ? "bg-[#2D2A26] text-white" : "hover:bg-[#F6F3EC]"}`}>{c.label}</button>
        ))}
      </div>

      <MultiUploadDropzone categories={CATS} onComplete={load} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {filtered.map((g) => (
          <div key={g.id} className="bg-[#FDFBF7] rounded-2xl overflow-hidden border border-[#2D2A26]/10">
            <img src={g.image_url} alt="" className="w-full aspect-square object-cover" />
            <div className="p-3">
              <div className="text-xs text-[#C87A5E] uppercase tracking-wider">{g.category}</div>
              <div className="text-sm truncate">{trFr(g.caption) || "—"}</div>
              <div className="flex gap-2 mt-2 text-xs">
                <button onClick={() => setEditing(g)} className="link-underline text-[#C87A5E]">Modifier</button>
                <button onClick={() => remove(g.id)} className="link-underline text-red-700">Supprimer</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <Modal onClose={() => setEditing(null)} title={editing.id ? "Modifier" : "Nouvelle photo"}>
          <div className="space-y-4">
            <div>
              <label className="overline block mb-1.5">category</label>
              <select value={editing.category} onChange={(e) => setEditing({ ...editing, category: e.target.value })} className="w-full border border-[#2D2A26]/15 rounded-xl px-4 py-2.5 text-sm">
                {CATS.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
              </select>
            </div>
            <ImageUploader value={editing.image_url} onChange={(v) => setEditing({ ...editing, image_url: v })} label="image_url" testid="gallery-image" />
            <BilingualField label="caption" value={editing.caption} onChange={(v) => setEditing({ ...editing, caption: v })} testid="gallery-caption" />
            <Input label="order" type="number" value={editing.order || 0} onChange={(v) => setEditing({ ...editing, order: Number(v) })} />
            <button onClick={save} className="btn-primary w-full justify-center" data-testid="gallery-save"><Save size={16} /> Enregistrer</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
